'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectableLabel = function SelectableLabel(_ref) {
  var appearance = _ref.appearance,
      label = _ref.label,
      group = _ref.group,
      selected = _ref.selected,
      iconUnselected = _ref.iconUnselected,
      iconSelected = _ref.iconSelected;

  var selectedClass = selected ? 'selected' : '';
  var icon = selected && iconSelected || !selected && iconUnselected;

  return _react2.default.createElement(
    'span',
    { className: 'SelectableLabel ' + appearance + ' ' + selectedClass },
    group && _react2.default.createElement(
      'span',
      { className: 'group' },
      group
    ),
    label,
    icon && _react2.default.createElement(_.Icon, { name: icon })
  );
};

SelectableLabel.propTypes = {
  /**
   * Which style to apply
   */
  appearance: _propTypes2.default.oneOf(['plain', 'filter', 'tag']),
  /**
   * Label for the selectable item.
   */
  label: _propTypes2.default.string.isRequired,
  /**
   * Group (displayed to the left of the label) for the selectable item.
   */
  group: _propTypes2.default.string,
  /**
   * Selected status. A boolean.
   */
  selected: _propTypes2.default.bool,
  /**
   * The name of the icon to append to the label when it is selected.
   */
  iconSelected: _propTypes2.default.string,
  /**
   * The name of the icon to append to the label when it is not selected.
   */
  iconUnselected: _propTypes2.default.string
};

SelectableLabel.defaultProps = {
  appearance: 'filter',
  iconSelected: 'x',
  selected: false
};

exports.default = SelectableLabel;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/SelectableLabel.js
// module id = 284
// module chunks = 0